// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_Hjz","cls2":"TransactionalPricingModal-cls2_i6G TransactionalPricingModal-cls1_Hjz"};